module.exports = __webpack_public_path__ + "static/media/APIFDF.48d3a280.png";